var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M13.1803 7.76225C12.6933 7.19356 12.472 6.70073 12.472 5.86347V5.57878C12.472 4.48772 12.2209 3.78474 11.675 3.08176C10.8335 1.99003 9.4169 1.33203 8.03014 1.33203H7.97117C6.61355 1.33203 5.24136 1.95981 4.38531 3.00723C3.80954 3.72431 3.52927 4.45751 3.52927 5.57878V5.86347C3.52927 6.70073 3.32255 7.19356 2.82098 7.76225C2.45192 8.18122 2.33398 8.7197 2.33398 9.3025C2.33398 9.88597 2.52547 10.4385 2.90976 10.8877C3.41133 11.4262 4.11962 11.77 4.84315 11.8297C5.89068 11.9493 6.93821 11.9942 8.00098 11.9942C9.06309 11.9942 10.1106 11.919 11.1588 11.8297C11.8817 11.77 12.59 11.4262 13.0915 10.8877C13.4752 10.4385 13.6673 9.88597 13.6673 9.3025C13.6673 8.7197 13.5494 8.18122 13.1803 7.76225Z",
    fill: "#F9B400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    opacity: 0.4,
    d: "M9.33917 12.819C9.0059 12.7478 6.97511 12.7478 6.64183 12.819C6.35693 12.8848 6.04883 13.0379 6.04883 13.3736C6.06539 13.6939 6.2529 13.9765 6.51263 14.1558L6.51197 14.1565C6.84789 14.4183 7.24212 14.5848 7.65491 14.6446C7.87488 14.6748 8.09883 14.6735 8.32676 14.6446C8.73888 14.5848 9.13311 14.4183 9.46904 14.1565L9.46837 14.1558C9.7281 13.9765 9.91561 13.6939 9.93218 13.3736C9.93218 13.0379 9.62408 12.8848 9.33917 12.819Z",
    fill: "#F9B400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f67fd803d9129fea6c8fd01e35c01671.svg";
export { ForwardRef as ReactComponent };